module.exports = __webpack_public_path__ + "img/usdc.ded7ad22.png";